import type FlowExtension from '@peekops/peek-extensions-framework/classes/FlowExtension'
import { FLOW_EXTENSION_PAGE_TYPENAMES } from '@peekops/peek-extensions-framework/classes/FlowExtension'

const PAGE_TARGET_LAST = 'LAST'

export function mutateConfigData(config: FlowConfig | null, extendables: any[] = []): FlowConfig | null {
  if (!config?.pages?.length || !extendables?.length) return config

  extendables.forEach((extension: FlowExtension) => {
    const { extendedFlowData } = extension

    if (!extendedFlowData) return

    extendedFlowData.forEach((pageData) => {
      const pageType = pageData.__typename

      if (!pageType) return

      pageData.extensionRef = extension
      // Stamp steps too — patched steps survive _mergeSteps without the page wrapper.
      pageData.steps?.forEach((step: any) => {
        step.extensionRef = extension
      })

      if (Object.values(FLOW_EXTENSION_PAGE_TYPENAMES).includes(pageType)) {
        config.pages = _insertExtensionPage(config.pages, pageData)
      } else {
        config.pages = _patchExistingPage(config.pages, pageData)
      }
    })
  })

  return config
}

function _insertExtensionPage(pages: PageConfig[], extendedPageData: any) {
  const pageTarget = extendedPageData.after ?? extendedPageData.before
  let pageIndex = pageTarget === PAGE_TARGET_LAST ? Math.max(pages.length - 1, 0) : pages.findIndex((page) => page.__typename === pageTarget)

  if (pageIndex === -1) return pages

  if (extendedPageData.after) {
    pageIndex++
  }

  pages.splice(pageIndex, 0, extendedPageData)

  return pages
}

function _patchExistingPage(pages: PageConfig[], pageData: any) {
  const pageIndex = pages.findIndex((page) => page.__typename === pageData.__typename)
  if (pageIndex === -1 || !pages[pageIndex]) return pages

  if (pageData.overwrite === true) {
    pages[pageIndex] = pageData
  } else {
    pages[pageIndex] = _mergePageData(pages[pageIndex], pageData)
  }

  return pages
}

function _mergePageData(basePage: PageConfig, patchPage: any) {
  basePage.steps = _mergeSteps(basePage.steps, patchPage.steps)
  // basePage.slots = _mergeSlots(basePage.slots, patchPage.slots)

  return basePage
}

function _mergeSteps(baseSteps: StepConfig[] = [], patchSteps: StepConfig[]) {
  patchSteps.forEach((patchStep: any) => {
    const patchStepTarget = patchStep.after ?? patchStep.before
    let stepIndex = patchStepTarget === PAGE_TARGET_LAST ? Math.max(baseSteps.length - 1, 0) : baseSteps.findIndex((step) => step.__typename === patchStepTarget)
    if (stepIndex === -1) return

    if (patchStep.after) {
      stepIndex++
    }

    baseSteps.splice(stepIndex, 0, patchStep)
  })

  return baseSteps;
}
